import clsx from 'clsx';
import {
  FormFieldAssignee,
} from 'dtos/formFieldAssignee';

type AssigneeField = {
  assignee?: FormFieldAssignee;
};

export function getFieldAssignee(field: AssigneeField): FormFieldAssignee {
  return field.assignee ?? FormFieldAssignee.Patient;
}

export function getFieldBoxClassNames(
  assignee: FormFieldAssignee,
  isSelected: boolean,
  isAutoFill = false,
): string {
  const isPatient = assignee === FormFieldAssignee.Patient;

  return clsx(
    'flex h-full w-full cursor-move items-center border-2',
    'transition-colors duration-150',
    isAutoFill && 'border-dotted',
    isPatient ? {
      'bg-secondary/5 text-secondary': !isSelected,
      '!border-secondary/30 !bg-secondary/30 !text-black': isSelected,
      'border-secondary/10 hover:!border-secondary/15 hover:!bg-secondary/25 hover:!text-black': !isSelected,
    } : {
      'border-violet-300/50 bg-violet-50/80 text-violet-800': !isSelected,
      '!border-violet-500 !bg-violet-200/80 !text-violet-950': isSelected,
      'hover:!border-violet-400 hover:!bg-violet-100/90 hover:!text-violet-900': !isSelected,
    },
  );
}

export function getDraftRectClassNames(assignee: FormFieldAssignee): string {
  const isPatient = assignee === FormFieldAssignee.Patient;

  return clsx(
    'absolute border-2 border-dashed',
    isPatient
      ? 'border-secondary/40 bg-secondary/20'
      : 'border-violet-400/60 bg-violet-100/60',
  );
}

export function getAssigneeSwatchClassName(assignee: FormFieldAssignee): string {
  const isPatient = assignee === FormFieldAssignee.Patient;

  return clsx(
    'h-3 w-3 shrink-0 rounded-sm border',
    isPatient
      ? 'border-secondary/30 bg-secondary/25'
      : 'border-violet-400/60 bg-violet-100/90',
  );
}
